"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetTrafficOutputStats($userId: String!) {\n    getTrafficOutputStats(userId: $userId) {\n      global {\n        total\n        user\n        unassigned\n        status {\n          EDITING\n          DRAFT\n          PENDING_MASTER\n          INTERNAL_REVIEW\n          PENDING_REVIEW\n          APPROVED\n          ON_HOLD\n        }\n        difficulty {\n          EASY\n          MODERATE\n          HARD\n          UNKNOWN\n        }\n      }\n      user {\n         status {\n          EDITING\n          INTERNAL_REVIEW\n          PENDING_REVIEW\n          ON_HOLD\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getTrafficOutputStatsQuery = (0, _graphqlTag.default)(_templateObject());
var getTrafficOutputStats = {
  query: getTrafficOutputStatsQuery,
  module: 'video',
  ignoreCache: true,
  buildVariables: function buildVariables(_ref) {
    var userId = _ref.userId;
    return {
      userId: userId
    };
  }
};
var _default = getTrafficOutputStats;
exports.default = _default;